import { CountryObj } from '../types';

export interface Options {
  localCurrencyCode: string;
  payoutCurrencyCodes: string[];
  sendCurrencyCodes: string[];
  payoutOptionCode: string;
  isIndicativeRateAvailable: boolean
}

export interface ServiceOptionsState {
  withdrawCountry: string;
  depositCountry: string;
  serviceOptions: Options[];
  isCashOutAllowed: string;
  isServerDown: boolean;
  indicativeRateCountry: boolean;
  cashOutCountries: string[];
  cashInCountries: string[];
  countriesDetails?: CountryObj[] | null;
  hasError: boolean;
  uiConfigs: UiConfig[];
  transactionId?: string;
  features?: FeatureFlags | null;
  config: ConfigFlags | null;
}

export interface ServiceOptionsRequest {
  token: string;
  language: string;
  operation: string;
  selectedWithdrawCountry?: string;
}

export interface ServiceOptionsResponse {
  language?: string;
  uiConfigs?: UiConfig[];
  withdrawCountry?: string;
  depositCountry?: string;
  serviceOptions?: Options[];
  isCashOutAllowed?: string;
  cashOutCountries?: string[];
  cashInCountries?: string[];
  countriesDetails?: CountryObj[] | null;
  errors?: Error[];
}

export interface LangLabels {
  code: string;
  cmsKey: string;
  additionalProperties?: any;
}
export interface UiConfig {
  additionalProperties?: {};
  displayFlashPage?: boolean;
  disableCashInCountry?: boolean;
  languageList?: LangLabels[];
  mapiCategoryErrorCodes?: string[];
  notSupportedUSStates: string[];
  statesAllowedIso2Countries?: string[];
  statesAllowedIso3Countries?: string[];
  supportedLocale?: string[];
}

export interface FeatureFlags {
  isPaymentOptionsEnabled: boolean
  isPaymentOptionsSubtitleEnabled: boolean
  isTierFilteringEnabled: boolean
  isUpdateIdEnabled: boolean
}

export interface ConfigFlags {
  isSignInEnabled: boolean
  isFirebaseEnabled: boolean
  isCashEnabled: boolean
  isDebitEnabled: boolean
  isBankAccountEnabled: boolean
  resetOtpTimerInSec: number
}

export const serviceOptionsMock = {
  transactionId: 'c2c465d7-505d-4022-9200-3fa723d86bbb',
  withdrawCountry: 'USA',
  cashOutCountries: [
    'ZAF',
    'ARG',
    'BRA',
    'CAN',
    'SLV',
    'IRL',
    'KEN',
    'PHL',
    'POL',
    'UKR',
    'GBR',
    'USA',
    'HUN',
    'AGO',
    'ATG',
    'AUS',
    'PER',
    'GRC',
    'AUT',
    'BHR',
    'BRB',
    'BEL',
    'BLZ',
    'BEN',
    'BTN',
    'BWA',
    'BRN',
    'BFA',
    'CMR',
    'CPV',
    'CAF',
    'TCD',
    'COL',
    'COM',
    'COG',
    'COD',
    'CIV',
    'CHL',
    'HRV',
    'DNK',
    'DJI',
    'DMA',
    'ECU',
    'SWZ',
    'ETH',
    'FJI',
    'FIN',
    'FRA',
    'GUF',
    'GAB',
    'GMB',
    'GHA',
    'GIB',
    'GRD',
    'GLP',
    'GUM',
    'GTM',
    'GNB',
    'GUY',
    'HND',
    'HKG',
    'ISL',
    'IND',
    'IDN',
    'ITA',
    'JAM',
    'JPN',
    'KOR',
    'XRK',
    'KWT',
    'KGZ',
    'LAO',
    'LBR',
    'LUX',
    'MDG',
    'MWI',
    'MYS',
    'MDV',
    'MLI',
    'MLT',
    'MHL',
    'MTQ',
    'MRT',
    'MUS',
    'MYT',
    'MEX',
    'FSM',
    'MNG',
    'MNE',
    'MSR',
    'MOZ',
    'MMR',
    'NLD',
    'NZL',
    'NER',
    'NOR',
    'OMN',
    'PSE',
    'PAN',
    'PRT',
    'PRI',
    'REU',
    'LCA',
    'MAF',
    'VCT',
    'WSM',
    'STP',
    'SAU',
    'SEN',
    'SYC',
    'SLE',
    'SGP',
    'SXM',
    'SVK',
    'SLB',
    'SSD',
    'ESP',
    'LKA',
    'SWE',
    'CHE',
    'TZA',
    'THA',
    'TLS',
    'TGO',
    'TON',
    'TCA',
    'TUV',
    'UGA',
    'ARE',
    'URY',
    'VUT',
    'VGB',
    'VIR',
    'ZMB',
    'ABW',
    'LBY',
    'NAM',
    'AFG',
    'ALB',
    'AIA',
    'ARM',
    'BHS',
    'BLR',
    'BMU',
    'BOL',
    'BIH',
    'BGR',
    'KHM',
    'CYM',
    'CRI',
    'CUW',
    'CYP',
    'CZE',
    'DOM',
    'EST',
    'GEO',
    'GNQ',
    'HTI',
    'ISR',
    'JOR',
    'KAZ',
    'LVA',
    'LBN',
    'MKD',
    'MDA',
    'NIC',
    'NGA',
    'PRY',
    'ROU',
    'RWA',
    'KNA',
    'SRB',
    'SUR',
    'TTO',
    'TUR',
    'UZB',
    'VEN',
    'VNM',
    'LTU',
    'DEU',
  ],
  indicativeRateCountry: false,
  isServerDown: false,
  serviceOptions: [
    {
      payoutOptionCode: 'WILL_CALL',
      payoutCurrencyCodes: ['USD'],
      localCurrencyCode: 'USD',
    },
  ],
  uiConfigs: [
    {
      disableCashInCountry: false,
      displayFlashPage: false,
      languageList: [
        {
          code: 'en-US',
          cmsKey: 'ENGLISH',
        },
        {
          code: 'es-US',
          cmsKey: 'SPANISH',
        },
      ],
      mapiCategoryErrorCodes: [
        'MAPI-20000',
        'MAPI-30000',
        'MAPI-45000',
        'MAPI-90000',
      ],
      notSupportedUSStates: ['US-AK', 'US-HI', 'US-LA', 'US-NY'],
      statesAllowedIso2Countries: ['US', 'MX', 'CA'],
      statesAllowedIso3Countries: ['USA', 'MEX', 'CAN'],
      supportedLocale: [
        'ru-RU',
        'en-US',
        'es-US',
        'uk-UA',
        'pt-PT',
        'fr-FR',
        'de-DE',
        'el-GR',
        'lt-LT',
        'it-IT',
        'ro-RO',
        'no-NO',
      ],
    },
  ],
};
